import React, { useState, useEffect } from 'react';
import { Container, Carousel, Image, Placeholder, Row, Col, Card } from 'react-bootstrap';
const AlumniSliders = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';    
    const DynamicSlides = ({stId}) => 
    {
        const[isLoading, setLoading] = useState(true);
        const[hpSlider,setSlider]=useState([])
        useEffect(()=>
        {
            const getSlider = async () => 
            {
                try 
                {
                    const response = await fetch(global.config.API_URL+"slider/byType/"+stId);
                    const result = await response.json();
                    if(result.length > 0 )
                    {
                        Promise.all(
                            result.map(e => {
                                const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImage")
                                    .then(upp => upp.json());
                                const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImageHi")
                                    .then(upb => upb.json());
                                return Promise.all([fetch1, fetch2])
                                    .then(([upp, upb]) => {
                                        return {
                                            ...e,
                                            upp,
                                            upb
                                        };
                                    });
                            })
                        ).then(allResponse => {   
                            allResponse.forEach((el, i) => {
                                result[i].slideImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                                result[i].slideImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                            });
                            setSlider(result);
                        }).catch(error => {
                            console.error('Slider File :', error);
                        });
                    }
                    if( global.config.IsPrint === true ) { console.info('Slider : Result',result); }         
                }
                catch (error) 
                {
                    console.error('Slider : Error', error.message);                
                }
                finally
                {
                    setLoading(false);
                }
            };
            getSlider();    
        },[stId])
        return (
            <React.Fragment>
                {isLoading ? (
                <Carousel id='carouselHero' data-bs-theme="dark" data-aos="flip-up" data-aos-duration="1500">
                    {[...Array(5)].map((_, index)=>(
                    <Carousel.Item key={index}>
                        <Placeholder xs={12} className="d-block w-100" style={{height:"400px"}} />
                    </Carousel.Item>
                    ))}
                </Carousel>
                ) : (
                <Carousel id='carouselHero' data-bs-theme="dark" data-aos="flip-up" data-aos-duration="1500">
                    {hpSlider.map((hs, index)=>(
                        <Carousel.Item key={index}>
                        {appLanguage === 'hi' ? 
                            (
                                hs.ss_display_en === "1" && hs.slideImageHi ? 
                                <Image src={hs.slideImageHi} fluid width={1400} height={440} alt={hs.ss_name_hi} loading="lazy" /> 
                                : hs.slideImageHi ? 
                                <Image src={hs.slideImageHi} fluid width={1400} height={440} alt={hs.ss_name_hi} loading="lazy" /> 
                                    : hs.slideImage ?
                                    <Image src={hs.slideImage} fluid width={1400} height={440} alt={hs.ss_name_hi} loading="lazy" /> 
                                    : null
                            ) : (
                                hs.slideImage ? 
                                <Image src={hs.slideImage} fluid width={1400} height={440} alt={hs.ss_name} loading="lazy" /> 
                                : null
                            )
                        }
                        </Carousel.Item>              
                    ))}
                </Carousel>
                )}
            </React.Fragment>
        );
    }
    return (
        <section style={{ backgroundImage: `url(${global.config.uploadPath + '363167611.png'})`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>
            <Container className="p-5 text-center">
                <Row className="g-3">
                    <Col lg={8}>
                        <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                            <Card.Body>
                                <DynamicSlides stId={27} />
                            </Card.Body>                                        
                        </Card>
                    </Col>
                    <Col lg={4}>
                        <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                            <Card.Body>
                                <DynamicSlides stId={28} />
                            </Card.Body>                                        
                        </Card>
                    </Col>                               
                </Row>              
            </Container>
        </section>
    );
};
export default AlumniSliders;